<template>
	<el-container>
		<el-main class="reviewTaskManageMain-wrap">
			<div class="reviewTaskManageMain mt6 shadowlaw">
				<div class="filter filterReviewDetail">
					<el-form
						ref="form"
						:model="form"
						label-width="80px"
						class="clearfix"
					>
						<!-- <el-form-item label="审查报告">
							<el-input
								v-model.trim="form.title__contains"
							></el-input>
						</el-form-item> -->
						<el-form-item label="审查文件">
							<el-input
								v-model.trim="form.author_name__contains"
							></el-input>
						</el-form-item>
						<el-form-item label="上传时间">
							<el-date-picker
								v-model="form.time"
								type="daterange"
								range-separator="至"
								start-placeholder="开始日期"
								end-placeholder="结束日期"
								value-format="yyyy-MM-dd"
							></el-date-picker>
						</el-form-item>
						<div class="operation fl operationReviewDetail">
							<a class="new f_transition" @click="resetFun">
								<i class="iconfont icon-zhongzhi"></i>
								重置
							</a>
							<a class="new f_transition" @click="searchTable">
								<i class="iconfont icon-chaxun1"></i>
								查询
							</a>
						</div>
					</el-form>
				</div>
				<div class="tableBox tableBoxReviewDetail">
					<el-table
						ref="multipleTable"
						:data="tableData"
						tooltip-effect="dark"
						style="width: 100%"
						v-loading="loading"
					>
						<!-- <el-table-column type="selection" width="66">
						</el-table-column> -->
						<el-table-column
							prop="title"
							label="审查文件"
							min-width="40%"
							align="center"
							:show-overflow-tooltip="true"
						>
						</el-table-column>
						<el-table-column
							prop="type__brief"
							label="审查类型"
							min-width="20%"
							:show-overflow-tooltip="true"
							align="center"
						>
						</el-table-column>
						<el-table-column
							prop="process__brief"
							label="审查进度"
							min-width="20%"
							:show-overflow-tooltip="true"
							align="center"
						>
						</el-table-column>
						<el-table-column
							prop="stage__brief"
							label="对应审查报告"
							min-width="40%"
							:show-overflow-tooltip="true"
							align="center"
						>
						</el-table-column>
						<el-table-column
							prop="status__brief"
							label="部门"
							min-width="20%"
							:show-overflow-tooltip="true"
							align="center"
						>
						</el-table-column>
						<el-table-column
							prop="author"
							label="上传人"
							min-width="20%"
							:show-overflow-tooltip="true"
							align="center"
						>
						</el-table-column>
						<el-table-column
							label="上传时间"
							min-width="20%"
							:show-overflow-tooltip="true"
							align="center"
						>
							<template slot-scope="scope">{{
								handleTime(scope.row.create_time)
							}}</template>
						</el-table-column>
					</el-table>
				</div>
				<div class="page pt15 pb15 clearfix pageReviewDetail">
					<el-pagination
						@size-change="handleSizeChangeDeclare"
						@current-change="handleCurrentChangeDeclare"
						:current-page.sync="currentPageDeclare"
						:page-size="pageSize"
						background
						layout="total ,prev, pager, next, jumper"
						:total="total"
					></el-pagination>
				</div>
				<div class="fileBox">
					<div class="fileBoxOperation hlh50 clearfix">
						<p class="fl title por">云南省艾滋病防治条例</p>
						<div
							class="operation fr pr36 mr35 operationReviewDetail"
						>
							<a class="new f_transition" @click="reportFun">
								<i class="iconfont icon-daochu"></i>
								导出
							</a>
							<a class="new f_transition" @click="deleteFun">
								<i class="iconfont icon-shanchu"></i>
								删除
							</a>
						</div>
					</div>
					<div class="fileBoxCon">
						<happy-scroll
							size="3"
							color="#c1c4c6"
							:hide-horizontal="true"
							resize
						>
							<div class="con">
								<h2 class="title">云南省艾滋病防治条例</h2>
								<p class="subtitle">（2006年11月30日云南省第十届人民代表大会常务委员会第二十六次会议通过）</p>
								<p class="paragraphMain">
									为了预防、控制艾滋病的传播和蔓延，救治艾滋病病毒感染者和艾滋病病人，保障人体健康和公共卫生，根据《中华人民共和国传染病防治法》、国务院《艾滋病防治条例》等有关法律、法规，结合本省实际，制定本条例。
								</p>
								<h3 class="chapter">第一章　总则</h3>
								<p class="paragraph">
									第一条　为了预防、控制艾滋病的传播和蔓延，救治艾滋病病毒感染者和艾滋病病人，保障人体健康和公共卫生，根据《中华人民共和国传染病防治法》、国务院《艾滋病防治条例》等有关法律、法规，结合本省实际，制定本条例。
								</p>
								<p class="paragraph">
									第二条　艾滋病防治工作坚持预防为主、防治结合的方针，建立政府领导、部门负责、社会参与的机制，采取宣传教育、行为干预和关怀救助等措施，实行综合防治。
								</p>
								<p class="paragraph">
									第一条　为了预防、控制艾滋病的传播和蔓延，救治艾滋病病毒感染者和艾滋病病人，保障人体健康和公共卫生，根据《中华人民共和国传染病防治法》、国务院《艾滋病防治条例》等有关法律、法规，结合本省实际，制定本条例。
								</p>
								<p class="paragraph">
									第二条　艾滋病防治工作坚持预防为主、防治结合的方针，建立政府领导、部门负责、社会参与的机制，采取宣传教育、行为干预和关怀救助等措施，实行综合防治。
								</p>		
								<p class="paragraph">
									第一条　为了预防、控制艾滋病的传播和蔓延，救治艾滋病病毒感染者和艾滋病病人，保障人体健康和公共卫生，根据《中华人民共和国传染病防治法》、国务院《艾滋病防治条例》等有关法律、法规，结合本省实际，制定本条例。
								</p>
								<p class="paragraph">
									第二条　艾滋病防治工作坚持预防为主、防治结合的方针，建立政府领导、部门负责、社会参与的机制，采取宣传教育、行为干预和关怀救助等措施，实行综合防治。
								</p>		
								<p class="paragraph">
									第一条　为了预防、控制艾滋病的传播和蔓延，救治艾滋病病毒感染者和艾滋病病人，保障人体健康和公共卫生，根据《中华人民共和国传染病防治法》、国务院《艾滋病防治条例》等有关法律、法规，结合本省实际，制定本条例。
								</p>
								<p class="paragraph">
									第二条　艾滋病防治工作坚持预防为主、防治结合的方针，建立政府领导、部门负责、社会参与的机制，采取宣传教育、行为干预和关怀救助等措施，实行综合防治。
								</p>		
								<p class="paragraph">
									第一条　为了预防、控制艾滋病的传播和蔓延，救治艾滋病病毒感染者和艾滋病病人，保障人体健康和公共卫生，根据《中华人民共和国传染病防治法》、国务院《艾滋病防治条例》等有关法律、法规，结合本省实际，制定本条例。
								</p>
								<p class="paragraph">
									第二条　艾滋病防治工作坚持预防为主、防治结合的方针，建立政府领导、部门负责、社会参与的机制，采取宣传教育、行为干预和关怀救助等措施，实行综合防治。
								</p>								　　 　　
							</div>
						</happy-scroll>
					</div>
				</div>
			</div>
		</el-main>
	</el-container>
</template>
<script>
export default {
	data() {
		return {
			//筛选条件start==
			form: {
				title__contains: "", //标题
				author_name__contains: "", //创建人
				time: [], //时间
			},
			//筛选条件end==

			//表格start==
			loading: false, //加载中
			tableData: [],
			multipleSelection: [], //表格选中数据
			//表格end==

			//分页start==
			currentPageDeclare: 1, //当前页
			total: 0, // 总共条数
			pageSize: 5, //每页的数量
			//分页end==
		};
	},
	created() {
		// this.tableFun(1);
	},
	methods: {
		//分页
		handleSizeChangeDeclare(size) {
			// console.log(`每页 ${size} 条`);
			this.pageSize = size;
			this.tableFun(this.currentPageDeclare);
		},
		handleCurrentChangeDeclare(currentPage) {
			// console.log(`当前页: ${currentPage}`);
			this.currentPageDeclare = currentPage;
			this.tableFun(this.currentPageDeclare);
		},
		//将时间中的T换成空格
		handleTime(t) {
			t = t.replace(new RegExp(/(T)/g), "\u00a0");
			return t;
		},
		//重置
		resetFun() {
			this.form.type = "null"; //审查类型
			this.form.status = "null"; //审查状态
			this.form.stage = "null"; //审查环节
			this.form.process = ""; //审查进度
			this.form.title__contains = ""; //标题
			this.form.author_name__contains = ""; //创建人
			this.form.time = []; //时间
			this.tableFun(1);
		},
		//域内检索
		searchTable() {
			this.tableFun(1);
		},
		//获取table中的数据
		tableFun(str) {
			this.loading = true; //加载中显示
			let startTime = "";
			let endTime = "";
			if (this.form.time&&this.form.time.length > 0) {
				startTime = this.form.time[0];
				endTime = this.form.time[1];
			} else {
				startTime = "";
				endTime = "";
			}
			this.axios
				.get(
					"/japi/check/check_items_handle/?page=" +
						str +
						"&page_num=" +
						this.pageSize +
						"&type=" +
						this.form.type +
						"&status=" +
						this.form.status +
						"&process=" +
						this.form.process +
						"&title__contains=" +
						this.form.title__contains +
						"&author_name__contains=" +
						this.form.author_name__contains +
						"&create_time__gte=" +
						startTime +
						"&create_time__lte=" +
						endTime
				)
				.then((res) => {
					console.log("审查任务管理表格数据======");
					console.log(res);
					if (res.status == 200) {
						this.total = res.data.data.sum;
						this.tableData = res.data.data.res;
						this.loading = false; //加载中隐藏
					} else {
						console.log("请求数据失败！");
						this.$message.error("请求数据失败！");
					}
				});
		},

		//导出
		reportFun() {
			
		},
		//删除
		deleteFun() {
			this.$confirm('请确认是否删除当前查看的智能审查原文数据？?', "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning",
				closeOnClickModal:false  //是否可通过点击遮罩关闭MessageBox
			}).then(() => { //确定
				
				// this.axios({
				// 	method: "post",
				// 	url: "/api/check/check_items_handle/",
				// 	data:{ //请求参数放在请求体
				// 		uuid:uuid
				// 	}
				// }).then(res => {
				// 	if (res.data.code == 200) {
				// 		console.log("删除成功======");
				// 		console.log(res);
				// 		//遮罩隐藏
				// 		this.loadingFile=false;
				// 		this.$message({
				// 			message: "删除成功",
				// 			type: "success",
				// 			duration: 3000
				// 		});
				// 		this.tableFun(this.currentPageDeclare);
				// 	} else if(res.data.code == 500){
				// 		this.$message({
				// 			message: "删除失败，请重新删除！",
				// 			type: "warning",
				// 			duration: 3000
				// 		});
				// 	}
				// });			
			}).catch(()=>{ //不加catch会报错
				this.$message({
					type: 'info',
					message: '已取消删除'
				});
			});
		},
	},
};
</script>
<style lang="scss" scoped>
@import "../../../../assets/css/mixin.scss"; //定义方法
@import "../../../../assets/css/recordReviewDetail.scss"; //智能审查详情页样式
</style>